import React from 'react'
import { TtButton } from '@23/react'
import { useConfirmationModal } from '../../../global/hooks/useConfirmationModal'

interface MultipleFilesUploadModalProps {
  onConfirm: () => void
  onCancel: () => void
}

const MultipleFilesUploadConfirmation = ({
  onConfirm,
  onCancel,
}: MultipleFilesUploadModalProps) => {
  return (
    <>
      <TtButton slot="footer" pill onClick={onConfirm}>
        OK
      </TtButton>
      <TtButton
        slot="footer"
        color="secondary"
        variant="outline"
        pill
        onClick={onCancel}
      >
        Cancel
      </TtButton>
    </>
  )
}

const useMultipleFilesUploadWarningModal = () =>
  useConfirmationModal(MultipleFilesUploadConfirmation, {
    title: `This will add multiple Slides to your WebinarTray`,
  })

const usePossiblyMultipleFilesUploadWarningModal = () =>
  useConfirmationModal(MultipleFilesUploadConfirmation, {
    title: `This will possibly add multiple Slides to your WebinarTray`,
  })

export {
  useMultipleFilesUploadWarningModal,
  usePossiblyMultipleFilesUploadWarningModal,
}
